module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0079.jpg?v=2f40f6d9";